<template>
    <div class="w100">
            
            <!-- <div style="height: 100vh;overflow: hidden;">
				<iframe style="width: 100%;height: 100vh;overflow: hidden;border: none;" :src="url"></iframe>
			</div> -->
		<div class="content" style="">
			<img src="../../assets/images/download/data_downlod_bg.png" class="bg" alt="" srcset="">
			<div class="main">
				<img src="../../assets/images/download/data_downlod_txt1.png" alt="" srcset="" class="txt1" style="margin: 50px 0;"><br>
				<img src="../../assets/images/download/data_downlod_txt2.png" alt="" srcset="" class="txt2"><br>
				<img src="../../assets/images/download/data_downlod_txt3.png" alt="" srcset="" class="txt3"><br>
				<a href="http://118.190.64.125:30001/唐宋数据Excel插件.zip"><img src="../../assets/images/download/data_downlod_btn.png" alt="" srcset="" class="txt4" style="margin: 50px 0;"></a>
			</div>
		
		</div>
    </div>
</template>

<script>
import { baseUrl } from '../../assets/js/common';
import $ from 'jquery'
export default {
    name: 'Download',
    components: { },
    data () {
        return {
            url: ''
        }
    },
    mounted () {
		var temp = this;
        // 初始化内容
		// setTimeout(function () {
			var windowWidth = $(window).width();
			//$('.bg').width(windowWidth);
			//$('.main').css({'left': (windowWidth / 2 - 325) + 'px'})
			// if (windowWidth > 1400) {
			// 	 $('.bg').width(windowWidth);
			// } else {
				// $('.bg').height('100vh');
				// var imgWidth = $('.bg').width();
				// var marginLeft = (imgWidth / 2) - (windowWidth / 2);
				
				// $('.bg').css({'height': '100vh', 'margin-left': -marginLeft});
			// }
			
			// if (windowWidth < 650) {
			// 	$('.main').css({'width': '300px'})
			// 	$('.txt1').css({'width': '60%'})
			// 	$('.txt2').css({'width': '40%'})
			// 	$('.txt3').css({'width': '85%'})
			// 	$('.txt4').css({'width': '55%'})
			// 	$('.main').css({'left': (windowWidth / 2 - 150) + 'px'})
			// } else {
			// 	$('.main').css({'left': (windowWidth / 2 - 325) + 'px'})
			// }
		// }, 1000)
    },
    methods: {
        
    },
}
</script>

<style scoped>
	.content {
		overflow: hidden;
		text-align: center;
		position: relative;
	}
	
	.main {
		position: absolute;
		top: 0px;
		left: 0;
		right: 0;
		z-index: 999;
		text-align: center;
		transform: scale(0.5);
		transform-origin: 50% 0;
	}
	.main img {
		margin-top: 40px;
	}
	.bg {
		/* height: 100vh; */
		width: 100vw;
		height: 100vh;
		min-height: 800px;
		text-align: center;
	}
</style>